<template>
  <van-tag class="x3-tag-day" v-bind="options" color="var(--c4)">按天</van-tag>
</template>

<script>
export default {
  props: {
    options: {
      type: Object,
      default: function () {
        return {
          color: 'var(--c1)',
          // size: 'large'
        };
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.x3-tag-day {
  margin-right: calc(var(--gap) * 4);
  border-radius: calc(var(--w) * 4);
}
</style>